import './CountryBlocked.sass';

import React, { FC } from 'react';

import { Button } from '$uikit';
import { IcFailed72 } from '$assets';
import { useTranslator } from '$hooks';

export const CountryBlocked: FC = () => {
  const t = useTranslator();

  return (
    <div className="CountryBlocked">
      <div className="CountryBlocked__icon">
        <IcFailed72 />
      </div>
      <div className="CountryBlocked__title">{t('country_blocked_title')}</div>
      <div className="CountryBlocked__caption">{t('country_blocked_description')}</div>
      <div className="CountryBlocked__action">
        <Button onClick={() => location.reload()}>{t('country_blocked_retry')}</Button>
      </div>
    </div>
  );
};
